import request from "../request";

/* Registration Details */
// Get Registration Form Detail List
export const getRegistrationList = (data, token) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/registration", { params: data })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Get Registration Form Details By Id
export const getRegistrationById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get(`/registration/${id}`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Regenerate PhonePe payment link for a registration
export const regeneratePaymentLink = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .post(`/registration/${id}/regenerate-payment-link`)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Patch Registration Form Details By Id
export const patchChangeStatusRegistrationDetailsById = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`/registration/` + id, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
// Patch Registration Form Details By Id
export const patchBulkChangeStatusRegistrationDetailsById = (data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .patch(`/registration/bulk/edit`, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Put Registration Form Details By Id
export const putEditRegistrationDetailsById = (id, data) => {
  return new Promise(async (resolve, reject) => {
    await request
      .put(`/registration/` + id, data)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Export registration list (JSON)
export const exportRegistrationList = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/registration/export", { params })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Download registration export as CSV
export const downloadRegistrationExportCsv = (params) => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/registration/export", {
        params: { ...params, format: "csv" },
        responseType: "blob",
      })
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Get participation event filter options
export const getParticipationEventOptions = () => {
  return new Promise(async (resolve, reject) => {
    await request
      .get("/registration/participation-events/options")
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};

// Delete Registration Form Details By Id
export const deleteRegistrationDetailsById = (id) => {
  return new Promise(async (resolve, reject) => {
    await request
      .delete(`/registration/` + id)
      .then((res) => {
        resolve(res.data);
      })
      .catch((e) => {
        reject(e);
      });
  });
};
